import { FC } from 'react'
import styled from 'styled-components'

import {
  opacity,
  rem,
  TagProps,
  TagVariant,
  Token,
  Tag as UiKitTag,
} from '@revolut-internal/ui-kit'

import { AgentStatus } from 'modules/Monitoring/types'
import { humanize } from 'modules/Monitoring/utils/format'

import { AgentAttendanceShiftState } from '../types'

const getTagConfig = (status: AgentAttendanceShiftState | AgentStatus) => {
  switch (status) {
    case AgentAttendanceShiftState.Past:
      return {
        bg: Token.color.greyTone5,
        color: Token.color.greyTone20,
      }
    case AgentStatus.Active:
      return {
        bg: opacity(Token.colorChannel.green, 0.1),
        color: Token.color.green,
      }
    case AgentStatus.Away:
      return {
        bg: opacity(Token.colorChannel.red, 0.1),
        color: Token.color.red,
      }
    default:
      return {
        bg: Token.color.greyTone8,
        color: Token.color.greyTone50,
      }
  }
}

const StyledTag = styled(UiKitTag).attrs<TagProps>(
  ({
    variant = TagVariant.FADED,
    bg = Token.color.greyTone50,
    color = Token.color.deepGrey,
  }) => ({
    variant,
    bg,
    color,
  }),
)`
  font-size: ${Token.fontSize.emphasis4};
  font-weight: ${Token.fontWeight.emphasis4};
  height: ${Token.size.s24};
  padding-left: ${rem(10)};
  padding-right: ${rem(10)};
`

type StatusTagProps = {
  status: AgentAttendanceShiftState
}

export const StatusTag: FC<StatusTagProps> = ({ status }) => {
  return <StyledTag {...getTagConfig(status)}>{humanize(status)}</StyledTag>
}
